/**
 * If the `Vacasa` global object is present, assume we are rendering as part of the CMS (https://www.vacasa.com/property-management).
 * @returns
 */
export const isInWagtailBlock = () => {
    return Vacasa !== undefined;
};
